export const NAVY = "#0a1244";
export const NAVY_SEC = "#101e6b";
export const RED = "#c0392b";
export const BLUE = "#3b82f6";
export const GREEN = "#16a34a";
export const GOLD = "#f4c542";
export const BDR = "#e2e5ef";

export const SCOPES = ["Data", "Profiles", "Settings", "Reports"];

export const S_INITIAL = 0;
export const S_CONFIRM = 1;
export const S_ACTIVE = 2;
export const S_REVOKE_CONFIRM = 3;
export const S_REVOKED = 4;
export const S_EXPIRED = 5;

export const STATUS_ACTIVE = "ACTIVE";
export const STATUS_REVOKED = "REVOKED";
export const STATUS_EXPIRED = "EXPIRED";

export const HISTORY_GRANTED = "GRANTED";
export const HISTORY_REVOKED = "REVOKED";
export const HISTORY_EXPIRED = "EXPIRED";

export const ROLE_OWNER = "ROLE_OWNER";
export const ROLE_ADMIN = "ROLE_ADMIN";
export const ROLE_MAINTENANCE_PERMIT = "ROLE_MAINTENANCE_PERMIT";
